module.exports = __webpack_public_path__ + "img/icono-experiencia-3.178ea5b1.svg";